// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Vcstart.css
// module id = 1172
// module chunks = 0